import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Map } from 'immutable';
import rootReducer from 'PreviewReducers/index';
import {
  getContainerBounds,
  getCanvasScale,
} from 'PreviewReducers/utils';
import {
  DIMENSIONS,
  CANVAS_SCALE,
  HEADLESS_PREVIEW,
  PORTRAIT,
  SELECTED_CONTAINER,
  SELECTED_LAYOUT,
} from 'PreviewConstants/';
import {
  VIEWPORT,
  UI,
  SELECTED,
  ADSTATES_PATH,
} from 'SharedConstants/';
import { getAdStates, getSelectedAdstate } from 'Selectors';

import App from 'PreviewComponents/App/App';
import { getInitialAppStateFromAdData, getInitialState } from 'Shared/utils/utils';
import saveStatuses from 'PreviewConfig/saveStatuses';

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    actionsBlacklist: [],
  })
  : compose;
/* eslint-enable */

class Preview extends Component {
  constructor(props) {
    super(props);
    const { adData, previewData, campaignAccess, approveAccess, logoSrc } = props;

    const bounds = getContainerBounds();

    const appState = getInitialAppStateFromAdData(adData, previewData);

    const ui = new Map({
      campaignAccess,
      approveAccess,
      logoSrc,
      bounds,
      fitToScreen: true,
      device: null,
      deviceOrientation: PORTRAIT,
    });

    let initialState = getInitialState({ appState, ui });
    let selectedArtboard = getSelectedAdstate(initialState);

    if (!selectedArtboard.key) {
      const firstArtboard = getAdStates(initialState).first();
      initialState = initialState.setIn(
        [...ADSTATES_PATH, firstArtboard.key, SELECTED],
        true,
      );
      selectedArtboard = getSelectedAdstate(initialState);
    }

    const initialViewport = selectedArtboard.get(VIEWPORT);
    initialState = initialState.setIn([UI, DIMENSIONS], initialViewport);
    const canvasScale = getCanvasScale(initialState);
    initialState = initialState.setIn([UI, CANVAS_SCALE], canvasScale);

    const queryParams = decodeURIComponent(location.search).replace('?', '').split('/');

    const defaultContainer = queryParams[0].replace(/[^a-zA-Z ]/g, '') || 'responsive';
    const headlessPreview = location.search.includes('?headless');
    initialState = initialState.setIn([UI, SELECTED_CONTAINER], defaultContainer);
    initialState = initialState.setIn([UI, HEADLESS_PREVIEW], headlessPreview);
    const defaultLayout = queryParams[1];
    initialState = initialState.setIn([UI, SELECTED_LAYOUT], defaultLayout);
    initialState = initialState.setIn([UI, 'saveStatus'], saveStatuses.saveReady);

    const store = createStore(
      rootReducer,
      initialState,
      composeEnhancers(
        applyMiddleware(thunk),
      ),
    );

    this.state = { store };
  }
  render() {
    const { store } = this.state;
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

Preview.propTypes = {
  adData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  previewData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  campaignAccess: PropTypes.bool.isRequired,
  approveAccess: PropTypes.bool.isRequired,
  logoSrc: PropTypes.string.isRequired,
};

export default Preview;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/index.jsx